import React from 'react';
import useIsMobile from "../../../hooks/useIsMobile";

export default function ShowInMobile(props) {
    const { children } = props;

    return useIsMobile() && children;
}